import { useState } from "react";
import { Link } from "react-router-dom";
import { Send } from "lucide-react";
import { primaryClass, WorkflowError, useWorkflowAction } from "./shared";

const fmt = (iso) => new Date(iso).toLocaleString("ja-JP", { timeZone: "Asia/Tokyo", month: "numeric", day: "numeric", hour: "2-digit", minute: "2-digit" });

const SendHistory = ({ sends }) => sends.length ? (
  <ul data-testid="guide-send-history" className="space-y-2">
    {sends.map((s) => (
      <li key={s.id} data-testid={`guide-send-${s.id}`} className="border border-line bg-ink/40 p-2 text-xs">
        <p className="text-gray-400">{fmt(s.at)} 送信（{s.by}）</p>
        <p className="mt-1 flex flex-wrap gap-2">
          {s.recipients.map((r) => <span key={r.notification_id} data-testid={`guide-send-recipient-${r.notification_id}`} className={`border px-2 py-0.5 ${r.read ? "border-emerald-500/50 text-emerald-300" : "border-amber-500/50 text-amber-300"}`}>{r.name}：{r.read ? "既読" : "未読"}</span>)}
        </p>
      </li>
    ))}
  </ul>
) : <p className="text-xs text-gray-600">まだ送信していません</p>;

export const GuideSender = ({ data, payload, disabled, onChanged }) => {
  const assigned = data.staff.filter((s) => (data.project.staff_ids || []).includes(s.id));
  const [picked, setPicked] = useState(assigned.map((s) => s.id));
  const { busy, error, run } = useWorkflowAction(data.project.id, onChanged);
  const toggle = (id) => setPicked((l) => (l.includes(id) ? l.filter((x) => x !== id) : [...l, id]));
  const send = async () => {
    if (await run("put", "photo-guide", payload, null)) await run("post", "photo-guide/send", { staff_ids: picked }, "保存してスタッフに送信しました");
  };
  return (
    <div data-testid="guide-sender" className="space-y-3 border border-accent/30 bg-panel p-4">
      <p className="text-sm font-bold text-white">スタッフに送信</p>
      {assigned.length === 0 ? (
        <p className="text-xs text-gray-400">担当スタッフがいません。<Link to="?tab=site" className="text-accent">「現場管理」タブで担当者を設定 →</Link></p>
      ) : (
        <div className="flex flex-wrap gap-4">
          {assigned.map((s) => <label key={s.id} className="flex items-center gap-2 text-sm text-gray-300"><input data-testid={`guide-send-staff-${s.id}`} type="checkbox" checked={picked.includes(s.id)} onChange={() => toggle(s.id)} className="accent-accent" />{s.display_name || s.name}<span className="text-xs text-gray-500">{s.employee_no || s.login_id}</span></label>)}
        </div>
      )}
      <button type="button" data-testid="guide-send-button" disabled={busy || disabled || picked.length === 0} onClick={send} className={primaryClass}><Send className="h-4 w-4" />保存してスタッフに送信</button>
      <WorkflowError error={error} id="guide-send-error" />
      <SendHistory sends={data.guide_sends || []} />
    </div>
  );
};
